import { render } from "./MatchmakerCharts.vue?vue&type=template&id=57a53566&scoped=true"
import script from "./MatchmakerCharts.vue?vue&type=script&lang=js"
export * from "./MatchmakerCharts.vue?vue&type=script&lang=js"

import "./MatchmakerCharts.vue?vue&type=style&index=0&id=57a53566&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3442\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a53566"]])

export default __exports__